import { Types } from "./types"

/**
 * Actions
 */
export const Creators = {
  setInstallmentValue: data => ({
    type: Types.SET_INSTALLMENT_VALUE,
    payload: { data },
  }),
}
